module.exports = __webpack_public_path__ + "img/143.eec906f2.png";